export const formatEmployeeName = (emp) => {
  if (!emp || typeof emp !== "object") return null;

  const direct = emp.full_name ?? emp.fullName ?? emp.employee_name ?? emp.name;
  if (typeof direct === "string" && direct.trim()) {
    return direct.trim();
  }

  const surname = emp.surname ?? emp.last_name ?? emp.lastName;
  const name = emp.first_name ?? emp.firstName;
  const patronymic = emp.patronymic ?? emp.middle_name ?? emp.middleName;
  const assembled = [surname, name, patronymic].filter(Boolean).join(" ");
  return assembled.trim() || null;
};

export const getEmployeeNames = (employees) => {
  const map = new Map();

  (employees || []).forEach((emp) => {
    const name = formatEmployeeName(emp);
    if (!name) return;
    const id = emp.user_id ?? emp.employee_id ?? emp.id;
    const key = id != null ? String(id) : name;
    if (!map.has(key)) map.set(key, name);
  });

  return Array.from(map.values()).sort((a, b) =>
    a.localeCompare(b, "ru", { sensitivity: "base" }),
  );
};

export const buildDismissalsByDepartmentId = (dismissals) => {
  const map = new Map();

  (dismissals?.items || []).forEach((item) => {
    (item.department || []).forEach((dept) => {
      if (!map.has(dept.id)) map.set(dept.id, []);
      map.get(dept.id).push(item);
    });
  });

  return map;
};
